import SearchRecipe, { SearchRecipeProps } from "./SearchRecipe";

export { SearchRecipe , SearchRecipeProps };

export default SearchRecipe;
